import { Components, Theme } from "@mui/material";
import { PrimaryColors, Shades } from "style/Colors";

export const MuiButtonBase: Components<Theme>["MuiButtonBase"] = {
  styleOverrides: {
    root: {
      "&.MuiPaginationItem-root": {
        backgroundColor: PrimaryColors.base,
        color: Shades.white,

        "&:hover": {
          backgroundColor: PrimaryColors.hover,
        },

        "&.Mui-selected": {
          backgroundColor: PrimaryColors.active,
          color: Shades.white,

          "&:hover": {
            backgroundColor: PrimaryColors.active,
          },
        },
      },
    },
  },
};
